import { TagType } from '@/app/components/search/utils';
import type { PlaceType } from '@lmn/common-search-widget/components/Autocompleter/services/types';
import { LeisureType } from '@/domainLogic/index.ts';

export const NOOP = () => {};

export const TYPE_MAP: Partial<Record<TagType, string | PlaceType | undefined>> = {
  [TagType.ANYWHERE]: 'Anywhere',
  [TagType.AIRPORT]: 'Airport',
  [TagType.BEACH]: 'beach',
  [TagType.CITY]: 'City',
  [TagType.CITY_BREAKS]: 'citybreaks',
  [TagType.COUNTRY]: 'Country',
  [TagType.TAG]: 'Tag',
  [TagType.EXOTIC]: 'exotic',
  [TagType.GEO]: undefined,
  [TagType.HOTEL]: 'Hotel',
  [TagType.SKI]: 'ski',
  [TagType.SPA]: 'spa',
  [TagType.TRAIN_STATION]: undefined,
};

export const LEISURE_TYPES_MAP = {
  [LeisureType.BEACH]: 'beach',
  [LeisureType.CITY_BREAKS]: 'citybreaks',
  [LeisureType.EXOTIC]: 'exotic',
  [LeisureType.SKI]: 'ski',
  [LeisureType.SPA]: 'spa',
};
export const HOLIDAY_TYPES: string[] = [TagType.BEACH, TagType.CITY_BREAKS, TagType.EXOTIC, TagType.SKI, TagType.SPA];
